export const brassDict = {
  trumpet: {
    'F#3': [['j', 'k', 'l']],
    Gb3: [['j', 'k', 'l']],
    G3: [['j', 'l']],
    'G#3': [['k', 'l']],
    Ab3: [['k', 'l']],
    A3: [['j', 'k']],
    'A#3': [['j']],
    Bb3: [['j']],
    B3: [['k']],
    'B#3': [[]],
    Cb4: [['k']],
    C4: [[]],
    'C#4': [['j', 'k', 'l']],
    Db4: [['j', 'k', 'l']],
    D4: [['j', 'l']],
    'D#4': [['k', 'l']],
    Eb4: [['k', 'l']],
    E4: [['j', 'k'], ['l']],
    'E#4': [['j']],
    Fb4: [['j', 'k'], ['l']],
    F4: [['j']],
    'F#4': [['k'], ['j', 'k', 'l']],
    Gb4: [['k'], ['j', 'k', 'l']],
    G4: [[], ['j', 'l']],
    'G#4': [['k', 'l']],
    Ab4: [['k', 'l']],
    A4: [['j', 'k'], ['l']],
    'A#4': [['j'], ['j', 'k', 'l']],
    Bb4: [['j'], ['j', 'k', 'l']],
    B4: [['k'], ['j', 'l']],
    'B#4': [[], ['k', 'l']],
    Cb5: [['k']],
    C5: [[], ['k', 'l']],
    'C#5': [
      ['j', 'k'],
      ['j', 'k', 'l'],
    ],
    Db5: [
      ['j', 'k'],
      ['j', 'k', 'l'],
    ],
    D5: [['j'], ['j', 'l']],
    'D#5': [['k'], ['k', 'l']],
    Eb5: [['k'], ['k', 'l']],
    E5: [[], ['j', 'k'], ['l'], ['j', 'k', 'l']],
    'E#5': [['j'], ['j', 'l']],
    Fb5: [[], ['j', 'k'], ['l'], ['j', 'k', 'l']],
    F5: [['j'], ['j', 'l']],
    'F#5': [['k'], ['k', 'l'], ['j', 'k', 'l']],
    Gb5: [['k'], ['k', 'l'], ['j', 'k', 'l']],
    G5: [[], ['j', 'l'], ['j', 'k'], ['k']],
    'G#5': [['k', 'l'], ['j'], ['j', 'k', 'l']],
    Ab5: [['k', 'l'], ['j'], ['j', 'k', 'l']],
    A5: [['j', 'k'], ['j', 'l'], ['k'], ['l']],
    'A#5': [['j'], ['j', 'k', 'l'], [], ['k', 'l']],
    Bb5: [['j'], ['j', 'k', 'l'], [], ['k', 'l']],
    B5: [['k'], ['j', 'l'], ['j', 'k'], ['l']],
    'B#5': [[], ['k', 'l'], ['j'], ['j', 'k', 'l']],
    Cb6: [['k'], ['j', 'l'], ['j', 'k'], ['l']],
    C6: [[], ['k', 'l'], ['j'], ['j', 'k', 'l']],
  },
  frenchHorn: {
    F3: [['e'], ['c']],
    'F#3': [['w'], ['q', 'w', 'e', 'c']],
    Gb3: [['w'], ['q', 'w', 'e', 'c']],
    G3: [[], ['e', 'q', 'c']],
    'G#3': [
      ['q', 'w'],
      ['q', 'w', 'c'],
    ],
    Ab3: [
      ['q', 'w'],
      ['q', 'w', 'c'],
    ],
    A3: [
      ['w', 'e'],
      ['w', 'e', 'c'],
      ['q', 'c'],
    ],
    'A#3': [['e'], ['e', 'c']],
    Bb3: [['e'], ['e', 'c']],
    B3: [['w'], ['w', 'c']],
    'B#3': [[], ['c']],
    Cb4: [['w'], ['w', 'c']],
    C4: [[], ['c']],
    'C#4': [
      ['w', 'e'],
      ['q', 'w', 'c'],
    ],
    Db4: [
      ['w', 'e'],
      ['q', 'w', 'c'],
    ],
    D4: [['e'], ['w', 'e', 'c']],
    'D#4': [['w'], ['e', 'c']],
    Eb4: [['w'], ['e', 'c']],
    E4: [[], ['w', 'c']],
    'E#4': [['e'], ['c']],
    Fb4: [[], ['w', 'c']],
    F4: [['e'], ['c'], ['q', 'w', 'c']],
    'F#4': [['w'], ['w', 'e', 'c']],
    Gb4: [['w'], ['w', 'e', 'c']],
    G4: [[], ['e', 'c']],
    'G#4': [
      ['q', 'w', 'c'],
      ['q', 'w'],
      ['w', 'c'],
    ],
    Ab4: [
      ['q', 'w', 'c'],
      ['q', 'w'],
    ],
    A4: [['w', 'e', 'c'], ['q', 'c'], ['c'], ['w', 'e']],
    'A#4': [['e', 'c'], ['e']],
    Bb4: [['e', 'c'], ['e']],
    B4: [['w', 'c'], ['w']],
    'B#4': [['c'], []],
    Cb5: [['w', 'c'], ['w']],
    C5: [['c'], []],
    'C#5': [
      ['q', 'w', 'c'],
      ['w', 'e'],
    ],
    Db5: [
      ['q', 'w', 'c'],
      ['w', 'e'],
    ],
    D5: [['w', 'e', 'c'], ['e']],
    'D#5': [['e', 'c'], ['w']],
    Eb5: [['e', 'c'], ['w']],
    E5: [['w', 'c'], ['c']],
    'E#5': [['c'], ['e', 'c'], ['e']],
    Fb5: [['w', 'c'], ['c']],
    F5: [['c'], ['e', 'c'], ['e'], ['q', 'w', 'c']],
    'F#5': [['w', 'c'], ['w']],
    Gb5: [['w', 'c'], ['w']],
    G5: [['c'], ['e', 'c'], []],
    'G#5': [['q', 'w', 'c'], ['w', 'c'], ['w'], ['q', 'w']],
    Ab5: [['q', 'w', 'c'], ['w', 'c'], ['w'], ['q', 'w']],
    A5: [['w', 'e', 'c'], ['c'], ['w', 'e']],
    'A#5': [['e', 'c'], ['e']],
    Bb5: [['e', 'c'], ['e']],
    B5: [['w', 'c'], ['w']],
    'B#5': [['c'], []],
    Cb6: [['w', 'c'], ['w']],
    C6: [['c'], []],
  },
  trombone: {
    E2: [['7']],
    'E#2': [['6']],
    Fb2: [['7']],
    F2: [['6']],
    'F#2': [['5']],
    Gb2: [['5']],
    G2: [['4']],
    'G#2': [['3']],
    Ab2: [['3']],
    A2: [['2']],
    'A#2': [['1']],
    Bb2: [['1']],
    B2: [['7']],
    'B#2': [['6']],
    Cb3: [['7']],
    C3: [['6']],
    'C#3': [['5']],
    Db3: [['5']],
    D3: [['4']],
    'D#3': [['3']],
    Eb3: [['3']],
    E3: [['2']],
    'E#3': [['1'], ['6']],
    Fb3: [['2'], ['7']],
    F3: [['1'], ['6']],
    'F#3': [['5']],
    Gb3: [['5']],
    G3: [['4']],
    'G#3': [['3'], ['7']],
    Ab3: [['3'], ['7']],
    A3: [['2'], ['6']],
    'A#3': [['1'], ['5']],
    Bb3: [['1'], ['5']],
    B3: [['4'], ['7']],
    'B#3': [['3'], ['6']],
    Cb4: [['4'], ['7']],
    C4: [['3'], ['6']],
    'C#4': [['2'], ['5']],
    Db4: [['2'], ['5']],
    D4: [['1'], ['4'], ['7']],
    'D#4': [['3'], ['6']],
    Eb4: [['3'], ['6']],
    E4: [['2'], ['5'], ['7']],
    'E#4': [['1'], ['4'], ['6']],
    Fb4: [['2'], ['5'], ['7']],
    F4: [['1'], ['4'], ['6']],
    'F#4': [['3'], ['5'], ['7']],
    Gb4: [['3'], ['5'], ['7']],
    G4: [['2'], ['4'], ['6']],
    'G#4': [['3'], ['5'], ['7']],
    Ab4: [['3'], ['5'], ['7']],
    A4: [['2'], ['4'], ['6']],
    'A#4': [['1'], ['3'], ['5']],
    Bb4: [['1'], ['3'], ['5']],
  },
  euphonium: {
    E2: [['j', 'k', 'l']],
    'E#2': [['j', 'l']],
    Fb2: [['j', 'k', 'l']],
    F2: [['j', 'l']],
    'F#2': [['k', 'l']],
    Gb2: [['k', 'l']],
    G2: [['j', 'k']],
    'G#2': [['j']],
    Ab2: [['j']],
    A2: [['k']],
    'A#2': [[]],
    Bb2: [[]],
    B2: [['j', 'k', 'l']],
    'B#2': [['j', 'l']],
    Cb3: [['j', 'k', 'l']],
    C3: [['j', 'l']],
    'C#3': [['k', 'l']],
    Db3: [['k', 'l']],
    D3: [['j', 'k'], ['l']],
    'D#3': [['j']],
    Eb3: [['j']],
    E3: [['k'], ['j', 'k', 'l']],
    'E#3': [[], ['j', 'l']],
    Fb3: [['k'], ['j', 'k', 'l']],
    F3: [[], ['j', 'l']],
    'F#3': [['k', 'l']],
    Gb3: [['k', 'l']],
    G3: [['j', 'k'], ['l']],
    'G#3': [['j'], ['j', 'k', 'l']],
    Ab3: [['j'], ['j', 'k', 'l']],
    A3: [['k'], ['j', 'l']],
    'A#3': [[], ['k', 'l']],
    Bb3: [[], ['k', 'l']],
    B3: [
      ['j', 'k'],
      ['j', 'k', 'l'],
    ],
    'B#3': [['j'], ['j', 'l']],
    Cb4: [
      ['j', 'k'],
      ['j', 'k', 'l'],
    ],
    C4: [['j'], ['j', 'l']],
    'C#4': [['k'], ['k', 'l']],
    Db4: [['k'], ['k', 'l']],
    D4: [[], ['j', 'k'], ['l'], ['j', 'k', 'l']],
    'D#4': [['j'], ['j', 'l']],
    Eb4: [['j'], ['j', 'l']],
    E4: [['k'], ['k', 'l'], ['j', 'k', 'l']],
    'E#4': [[], ['j', 'l'], ['j', 'k'], ['k']],
    Fb4: [['k'], ['k', 'l'], ['j', 'k', 'l']],
    F4: [[], ['j', 'l'], ['j', 'k'], ['k']],
    'F#4': [['k', 'l'], ['j'], ['j', 'k', 'l']],
    Gb4: [['k', 'l'], ['j'], ['j', 'k', 'l']],
    G4: [['j', 'k'], ['j', 'l'], ['k'], ['l']],
    'G#4': [['j'], ['j', 'k', 'l'], [], ['k', 'l']],
    Ab4: [['j'], ['j', 'k', 'l'], []],
    A4: [['k'], ['j', 'l'], ['j', 'k'], ['l']],
    'A#4': [[], ['k', 'l'], ['j'], ['j', 'k', 'l']],
    Bb4: [[], ['k', 'l'], ['j'], ['j', 'k', 'l']],
  },
  tuba: {
    E1: [
      ['k', ';'],
      ['j', 'k', 'l'],
    ],
    'E#1': [[';'], ['j', 'l']],
    Fb1: [
      ['k', ';'],
      ['j', 'k', 'l'],
    ],
    F1: [[';'], ['j', 'l']],
    'F#1': [['k', 'l']],
    Gb1: [['k', 'l']],
    G1: [['j', 'k'], ['l']],
    'G#1': [['j']],
    Ab1: [['j']],
    A1: [['k']],
    'A#1': [[]],
    Bb1: [[]],
    B1: [
      ['k', ';'],
      ['j', 'k', 'l'],
    ],
    'B#1': [[';'], ['j', 'l']],
    Cb2: [
      ['k', ';'],
      ['j', 'k', 'l'],
    ],
    C2: [[';'], ['j', 'l']],
    'C#2': [['k', 'l']],
    Db2: [['k', 'l']],
    D2: [['j', 'k'], ['l']],
    'D#2': [['j']],
    Eb2: [['j']],
    E2: [['k'], ['j', 'k', 'l']],
    'E#2': [[], ['j', 'l']],
    Fb2: [['k'], ['j', 'k', 'l']],
    F2: [[], ['j', 'l']],
    'F#2': [['k', 'l']],
    Gb2: [['k', 'l']],
    G2: [['j', 'k'], ['l']],
    'G#2': [['j']],
    Ab2: [['j']],
    A2: [['k']],
    'A#2': [[], ['k', 'l']],
    Bb2: [[], ['k', 'l']],
    B2: [
      ['j', 'k'],
      ['j', 'k', 'l'],
    ],
    'B#2': [['j'], ['j', 'l']],
    Cb3: [
      ['j', 'k'],
      ['j', 'k', 'l'],
    ],
    C3: [['j'], ['j', 'l']],
    'C#3': [['k'], ['k', 'l']],
    Db3: [['k'], ['k', 'l']],
    D3: [[], ['j', 'k']],
    'D#3': [['j']],
    Eb3: [['j']],
    E3: [['k']],
    'E#3': [[]],
    Fb3: [['k']],
    F3: [[]],
    'F#3': [['k', 'l']],
    Gb3: [['k', 'l']],
    G3: [['j', 'k']],
    'G#3': [['j']],
    Ab3: [['j']],
    A3: [['k']],
    'A#3': [[], ['j']],
    Bb3: [[], ['j']],
  },
};
